'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoIosTimerOutline = function IoIosTimerOutline(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm18.3 21.3l-0.1-0.2s-7-9.2-6.7-9.4 9.4 6.7 9.4 6.7c0.1 0 0.1 0.1 0.2 0.2 0.4 0.4 0.6 0.9 0.6 1.4 0 1.1-0.9 2-1.9 2-0.7 0-1.1-0.3-1.5-0.8z m1.5-17.5c8.9 0 16.2 7.2 16.2 16.2s-7.3 16.3-16.2 16.3-16.3-7.3-16.3-16.3c0-4.5 1.8-8.5 4.8-11.5l0.9 1c-2.7 2.7-4.4 6.4-4.4 10.5 0 8.3 6.7 14.9 15 14.9s14.9-6.6 14.9-14.9c0-7.8-6-14.3-13.7-14.9v7.4h-1.2v-8.7z' })
        )
    );
};

exports.default = IoIosTimerOutline;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/ios-timer-outline.js
// module id = 2304
// module chunks = 0